import './text-alert.scss'

export const TextAlert = ({ backgroundColor, text }: { backgroundColor: string; text: string }) => {
  return (
    <div className="TextAlert__container" style={{ backgroundColor }}>
      <span className="TextAlert__text">{text}</span>
    </div>
  )
}
